export const TENANTS_REPORT_ADDITIONAL_FIELDS = 'tenantsReportAdditionalFileds';
